<template>
  <v-card class="vpd-confirm-otp-panel">
    <v-card-title class="headline text-center">
      Ellenőrizze az e-mailjeit!
    </v-card-title>

    <v-alert
      v-model="alert"
      :type="alertType"
      close-text="Bezárás"
      dismissible
      @click="alert = false"
    >
      {{ alertMessage }}
    </v-alert>

    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="confirm">
      <v-row justify="center">
        <v-col align="center" class="subtitle-1">
          Biztonsági okokból küldtünk Önnek egy egyszer használatos kódot az e-mail címére. </br> Írja be a kapott kódot az alábbi mezőbe a folytatáshoz. Ha nem találja az e-mailt, ellenőrizze a Spam/Promóciók mappát is.
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col align="center" cols="4">
          <v-text-field
            label="Hitelesítő kód"
            outlined
            v-model="otpCode"
            :rules="otpRules"
            maxlength="6"
            ref="otpInput"
          />
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col align="center">
          <v-btn class="primary fix-width" type="submit">
            Folytatás
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import "./_vpd-confirm-otp-panel.scss";

export default {
  name: "vpd-confirm-otp-panel",
  data() {
    return {
      alert: false,
      alertType: "error",
      alertMessage: "",
      valid: false,
      otpCode: "",
      otpRules: [
        (v) => !!v || "A hitelesítő kód kötelező",
        (v) => /^\d{6}$/.test(v) || "A kód 6 számjegyből áll",
      ],
    };
  },
  methods: {
    showAlert(text, type) {
      this.alert = true;
      this.alertType = type;
      this.alertMessage = text;
    },
    confirm() {
      if (this.$refs.form.validate()) {
        this.$emit("submit", this.otpCode);
      }
    },
  },
};
</script>
